<template>
  <div>
    <div class="row q-mb-sm q-mt-lg">
      <div class="text-bold">
        Style
      </div>
    </div>
    <div class="row q-col-gutter-md">
      <q-checkbox
        v-model="section.config.showButton"
        class="col-3"
        label="Show Button"
        bottom-slots
      />
      <q-checkbox
        v-model="section.config.showIcon"
        class="col-3"
        label="Show Button Icon"
        bottom-slots
      />
      <q-checkbox
        v-model="section.config.showSiteSelector"
        class="col-3"
        label="Show Site Selector"
        bottom-slots
      />
      <q-checkbox
        v-model="section.config.showDateSeparators"
        class="col-3"
        label="Show Dropdown Date Separators"
        bottom-slots
      />
    </div>
    <div class="row q-mb-sm q-mt-lg">
      <div class="text-bold">
        Filter
      </div>
    </div>
    <div class="row q-col-gutter-md q-mb-md">
      <q-select
        v-model="section.titleClassId"
        label="Title Class"
        dense
        outlined
        map-options
        :options="titleClasses.data"
        clearable
        option-label="name"
        option-value="id"
        emit-value
        :style="{ width: $q.screen.lt.sm ? '150px' : undefined }"
        class="col-6 col-sm-3"
      />
    </div>
    <div class="row q-mb-sm q-mt-lg">
      <div class="text-bold">
        Content
      </div>
    </div>
    <div class="row q-mb-xl q-mt-lg">
      <showing-badge-select
        :model="section"
        label="Showing Badges"
        field-name="showingBadgeIds"
        class="col-6 col-sm-6"
      />
    </div>
    <preview
      :section="section"
      class="q-mb-xl"
    />
  </div>
</template>

<script>

import Section from 'src/models/page/Section'
import ShowingBadgeSelect from 'src/modules/admin/showing-badge/components/ShowingBadgeSelect.vue'
import Preview from 'src/modules/consumer/components/Preview'

export default {
  name: 'ShowtimeQuickSelectorEditor',
  components: {
    Preview,
    ShowingBadgeSelect
  },
  props: {
    section: {
      type: Section,
      required: true
    }
  },
  configuration: ['titleClasses']
}

</script>
